import React from 'react';
import style from './navbarCompoStyle.module.css';
import playstore from '../../assets/images/Section-Footer-Button-Download-Playstore-Large.svg';
import sepakatLogo from '../../assets/images/icon-logo.svg';
class NavbarCompo extends React.Component {
  render() {
    return (
      // <div className={this.state.show ? `${style.hidden}` : ` ${style.active}`}>
      <div className={`${style.navbar2} container-fluid sticky-top bg-light `}>
        <div className="container-fluid navbar2">
          <div className="container">
            <nav className={`navbar navbar-expand-lg ${style.nav}`}>
              <div className="container-fluid">
                <img src={sepakatLogo} alt="" className={style.logoSepakat} />
                <a className={`navbar-brand ${style.brandName}`} href="/">
                  Sepakat
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarNavDropdown"
                >
                  <ul className={`navbar-nav ${style.navUl}`}>
                    <li className={`nav-item ${style.navItems}`}>
                      <a
                        className={`nav-link active ${style.item} me-4`}
                        aria-current="page"
                        href="/"
                      >
                        Beranda
                      </a>
                    </li>
                    <li
                      className="nav-item dropdown"
                      style={{
                        display: 'none',
                      }}
                    >
                      <a
                        className={`nav-link active dropdown-toggle me-4 ${style.item}`}
                        href="/#"
                        id="navbarDropdownMenuLink"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Gabung Sepakat
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="navbarDropdownMenuLink"
                      >
                        <li>
                          <a
                            className={`dropdown-item ${style.item}`}
                            href="/#"
                          >
                            Jadi Agen
                          </a>
                        </li>
                        <li>
                          <a
                            className={`dropdown-item ${style.item}`}
                            href="/#"
                          >
                            Karir
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className={'nav-item dropdown'}>
                      <a
                        className={`nav-link active dropdown-toggle me-4 ${style.item}`}
                        href="/#"
                        id="navbarDropdownMenuLink"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Konten
                      </a>
                      <ul
                        className={`dropdown-menu ${style.dropDownMenu}`}
                        aria-labelledby="navbarDropdownMenuLink"
                      >
                        <li>
                            <a
                              className={`dropdown-item ${style.item}`}
                              href="/konten-video"
                            >
                              Video
                            </a>
                        </li>
                        <li>
                            <a
                              className={`dropdown-item ${style.item}`}
                              href="/konten-artikel"
                            >
                              Artikel
                            </a>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item">
                        <a
                          className={`nav-link active item1 ${style.item}`}
                          aria-current="page"
                          href="/tentang-kami"
                        >
                          Tentang Kami
                        </a>
                    </li>
                  </ul>
                </div>
                <div className={style.downloadWrapper}>
                  <a href="https://play.google.com/store/apps/details?id=id.asc.sepakat">
                    <img src={playstore} alt="" width={150} />
                  </a>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      // </div>
    );
  }
}

export default NavbarCompo;
//scroll = ('removeClass').scrollTop
